import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  opacity: 0;\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  text-align: left;\n  position: relative;\n  box-sizing: border-box;\n  box-shadow: ", ";\n  background-color: ", ";\n  padding: ", ";\n  white-space: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Popper } from 'react-popper';
import AppearTransition from '../Transitions/AppearTransition';
import { CARD_BORDER_RADIUS_EXTRA_LARGE, CARD_BORDER_RADIUS_LARGE, CARD_BORDER_RADIUS_MEDIUM, CARD_BORDER_RADIUS_SMALL, TOOLTIP_BLUR_RADIUS } from '../constants';
import { BLACK_OVERLAY, SENSATION_WHITE } from '../colors';
import { SHADOW_FOCUSED } from '../shadows';
import { zIndexValue as zIndexPosition } from '../helpers/position';
import { TOOLTIP_MAX_WIDTH, TOOLTIP_MULTILINE_PADDING, TOOLTIP_SIMPLE_PADDING } from './constants';
import { APPEAR_TRANSITION_DURATION } from '../Transitions/AppearTransition/constants';
import { getPx } from '../helpers/common';
import { userSelectNoneStyle } from '../tokens/user-select';
import { pointerEventAutoStyle, pointerEventsNoneStyle } from '../tokens/pointer-events';
import { borderRadius } from '../style/border-radius';
import { height } from '../style/height';
import { width } from '../style/width';
import { maxWidth } from '../style/max-width';
var BORDER_RADIUS = {
  small: CARD_BORDER_RADIUS_SMALL,
  medium: CARD_BORDER_RADIUS_MEDIUM,
  large: CARD_BORDER_RADIUS_LARGE,
  'extra-large': CARD_BORDER_RADIUS_EXTRA_LARGE
};
var StyledContentWrapper = styled.div(_templateObject(), SHADOW_FOCUSED, function (_ref) {
  var $inverse = _ref.$inverse;
  return $inverse ? BLACK_OVERLAY : SENSATION_WHITE;
}, function (_ref2) {
  var $multiline = _ref2.$multiline,
      $noPadding = _ref2.$noPadding;
  return $noPadding ? 0 : $multiline ? TOOLTIP_SIMPLE_PADDING : TOOLTIP_MULTILINE_PADDING;
}, function (_ref3) {
  var $multiline = _ref3.$multiline;
  return $multiline ? 'normal' : 'nowrap';
}, function (_ref4) {
  var _ref4$$size = _ref4.$size,
      $size = _ref4$$size === void 0 ? 'small' : _ref4$$size;
  return borderRadius(BORDER_RADIUS[$size] || BORDER_RADIUS.small);
}, function (_ref5) {
  var $multiline = _ref5.$multiline,
      value = _ref5.$width;
  return value ? width(value) : $multiline && maxWidth(TOOLTIP_MAX_WIDTH);
}, function (_ref6) {
  var value = _ref6.$height;
  return value && height(value);
}, function (_ref7) {
  var $withOverflowHidden = _ref7.$withOverflowHidden;
  return $withOverflowHidden && "overflow: hidden;";
});
var MeasureWrapper = styled.div(_templateObject2(), userSelectNoneStyle, pointerEventsNoneStyle);
var ContentWrapper = styled.div(_templateObject3(), pointerEventAutoStyle);
var TooltipWrapper = styled.div(_templateObject4(), function (_ref8) {
  var $trigger = _ref8.$trigger;
  return $trigger === 'hover' ? pointerEventsNoneStyle : '';
}, function (_ref9) {
  var $blurred = _ref9.$blurred;
  return $blurred ? "backdrop-filter: blur(" + getPx(TOOLTIP_BLUR_RADIUS) + ");" : '';
});
export var TooltipContent = function TooltipContent(_ref10) {
  var _ref10$size = _ref10.size,
      size = _ref10$size === void 0 ? 'small' : _ref10$size,
      _ref10$appearType = _ref10.appearType,
      appearType = _ref10$appearType === void 0 ? 'slide' : _ref10$appearType,
      _ref10$position = _ref10.position,
      position = _ref10$position === void 0 ? 'top' : _ref10$position,
      _ref10$withOverflowHi = _ref10.withOverflowHidden,
      withOverflowHidden = _ref10$withOverflowHi === void 0 ? false : _ref10$withOverflowHi,
      _ref10$animate = _ref10.animate,
      animate = _ref10$animate === void 0 ? true : _ref10$animate,
      _ref10$offset = _ref10.offset,
      offset = _ref10$offset === void 0 ? 8 : _ref10$offset,
      _ref10$noFlip = _ref10.noFlip,
      noFlip = _ref10$noFlip === void 0 ? true : _ref10$noFlip,
      _ref10$multiline = _ref10.multiline,
      multiline = _ref10$multiline === void 0 ? false : _ref10$multiline,
      _ref10$trigger = _ref10.trigger,
      trigger = _ref10$trigger === void 0 ? 'hover' : _ref10$trigger,
      content = _ref10.content,
      _ref10$zIndex = _ref10.zIndex,
      zIndex = _ref10$zIndex === void 0 ? zIndexPosition('tooltip') : _ref10$zIndex,
      _ref10$noPadding = _ref10.noPadding,
      noPadding = _ref10$noPadding === void 0 ? false : _ref10$noPadding,
      _ref10$withMargin = _ref10.withMargin,
      withMargin = _ref10$withMargin === void 0 ? false : _ref10$withMargin,
      width = _ref10.width,
      height = _ref10.height,
      _ref10$show = _ref10.show,
      show = _ref10$show === void 0 ? true : _ref10$show,
      _ref10$inverse = _ref10.inverse,
      inverse = _ref10$inverse === void 0 ? false : _ref10$inverse,
      _ref10$blurred = _ref10.blurred,
      blurred = _ref10$blurred === void 0 ? false : _ref10$blurred,
      wrapperStyle = _ref10.wrapperStyle,
      customWrapper = _ref10.customWrapper,
      parentQuerySelector = _ref10.parentQuerySelector,
      parentElement = _ref10.parentElement,
      parentRef = _ref10.parentRef,
      childRef = _ref10.childRef,
      props = _objectWithoutPropertiesLoose(_ref10, ["size", "appearType", "position", "withOverflowHidden", "animate", "offset", "noFlip", "multiline", "trigger", "content", "zIndex", "noPadding", "withMargin", "width", "height", "show", "inverse", "blurred", "wrapperStyle", "customWrapper", "parentQuerySelector", "parentElement", "parentRef", "childRef"]);

  var popperModifiers = [{
    name: 'offset',
    options: {
      offset: [0, offset]
    }
  }, {
    name: 'flip',
    enabled: !noFlip
  }, withMargin && {
    name: 'preventOverflow',
    options: {
      padding: 8
    }
  }].filter(function (modifier) {
    return !!modifier;
  });
  var renderTooltip = useCallback(function (placement) {
    if (placement === void 0) {
      placement = 'top';
    }

    return /*#__PURE__*/React.createElement(StyledContentWrapper, _extends({
      $position: placement,
      $size: size,
      $offset: offset,
      $multiline: multiline,
      $noPadding: noPadding,
      $width: width,
      $height: height,
      $withOverflowHidden: withOverflowHidden,
      $inverse: inverse,
      $blurred: blurred
    }, props), content);
  }, [size, offset, multiline, noPadding, width, height, withOverflowHidden, content, inverse, blurred, props]);
  var renderContent = useCallback(function (placement) {
    return customWrapper ? customWrapper(renderTooltip(placement), placement) : wrapperStyle ? /*#__PURE__*/React.createElement("div", {
      style: wrapperStyle
    }, renderTooltip(placement)) : renderTooltip(placement);
  }, [customWrapper, renderTooltip, wrapperStyle]);
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(Popper, {
    placement: position,
    referenceElement: parentRef.current,
    modifiers: popperModifiers
  }, function (_ref11) {
    var placement = _ref11.placement,
        popperRef = _ref11.ref,
        style = _ref11.style;
    // prepare tooltip content depending on wrapper parameters passed by
    var content = renderContent(placement);
    return /*#__PURE__*/React.createElement(TooltipWrapper, {
      style: _objectSpread(_objectSpread({}, style), {}, {
        zIndex: zIndex
      }),
      ref: function ref(_ref12) {
        if (_ref12) {
          // @ts-expect-error Popper set ref signature
          popperRef(_ref12);
          childRef.current = _ref12;
        }
      },
      $position: placement,
      $offset: offset,
      $trigger: trigger,
      $blurred: blurred
    }, animate ? !placement ? /*#__PURE__*/React.createElement(MeasureWrapper, null, content) : /*#__PURE__*/React.createElement(AppearTransition, {
      type: appearType,
      show: show,
      duration: APPEAR_TRANSITION_DURATION,
      placement: placement
    }, content) : /*#__PURE__*/React.createElement(ContentWrapper, null, content));
  }), parentElement || (parentQuerySelector ? document.querySelector(parentQuerySelector) : document.body));
};